/* Copyright (C) Okahu Inc 2023-2024. All rights reserved. */

'use client';

import { useContext } from 'react';
import { AuthContext } from '@/context';

export const useAuth = () => {
  return useContext(AuthContext);
};
